/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/menu.js